module.exports = __webpack_public_path__ + "img/s5.a72ec7f8.png";